(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1935],{

/***/ 85642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgArrowRightBlack(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.985,
    height: 12,
    viewBox: "0 0 11.985 12"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M11.91 5.619a1 1 0 00-.21-.33l-5-5a1.003 1.003 0 10-1.419 1.419l3.302 3.296H1a1 1 0 000 2h7.584l-3.3 3.287A1 1 0 106.7 11.704l5-5a1.033 1.033 0 00.21-1.089z",
    fill: "##08123B"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowRightBlack);

/***/ }),

/***/ 71069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ OnScrollFadeIn; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../core/dist/node_modules/style-inject/dist/style-inject.es.js
var style_inject_es = __webpack_require__(36474);
;// CONCATENATED MODULE: ../core/dist/components/onscrollfadein/OnScrollFadeIn.scss.js


var css_248z = ".fade-in-section {\n  opacity: 0;\n  transform: translateY(25vh);\n  visibility: hidden;\n  transition: opacity 1200ms ease-out, transform 600ms ease-out, visibility 1200ms ease-out;\n  will-change: opacity, transform, visibility;\n}\n\n.fade-in-section.is-visible {\n  opacity: 1;\n  transform: none;\n  visibility: visible;\n}";
(0,style_inject_es/* default */.Z)(css_248z);


//# sourceMappingURL=OnScrollFadeIn.scss.js.map

;// CONCATENATED MODULE: ../core/dist/components/onscrollfadein/OnScrollFadeIn.js



const OnScrollFadeIn = ({ children }) => {
    const [isVisible, setVisible] = react.useState(false);
    const domRef = (0,react.useRef)();
    (0,react.useEffect)(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => setVisible(entry.isIntersecting));
        });
        observer.observe(domRef.current);
    }, []);
    return (react.createElement("div", { className: `fade-in-section ${isVisible ? "is-visible" : ""}`, ref: domRef }, children));
};


//# sourceMappingURL=OnScrollFadeIn.js.map


/***/ }),

/***/ 81310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AboutUs; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/aboutus/Aboutus.module.scss
var Aboutus_module = __webpack_require__(51295);
var Aboutus_module_default = /*#__PURE__*/__webpack_require__.n(Aboutus_module);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./components/aboutus/banner/banner-mob/BannerMob.module.scss
var BannerMob_module = __webpack_require__(50249);
var BannerMob_module_default = /*#__PURE__*/__webpack_require__.n(BannerMob_module);
// EXTERNAL MODULE: ../core/dist/components/app-anchor/A.js
var A = __webpack_require__(70561);
;// CONCATENATED MODULE: ./assets/icons/arrowDownWhite.svg
var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgArrowDownWhite(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14.828,
    viewBox: "0 0 14 14.828"
  }, props), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("style", null, ".arrowDownWhite_svg__arrow-right_b{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"))), _path || (_path = /*#__PURE__*/react.createElement("path", {
    className: "arrowDownWhite_svg__arrow-right_b",
    d: "M1 7.414h12M7 1.414l6 6-6 6"
  })));
}

/* harmony default export */ var arrowDownWhite = (SvgArrowDownWhite);
// EXTERNAL MODULE: ../../node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(70423);
// EXTERNAL MODULE: ./components/utils/AppImg.tsx
var AppImg = __webpack_require__(17073);
// EXTERNAL MODULE: ../core/dist/methods/getTransporterFigure.js
var getTransporterFigure = __webpack_require__(98819);
;// CONCATENATED MODULE: ./components/aboutus/banner/banner-mob/BannerMob.tsx









var BannerMob = function() {
    var scrollToSection = function() {
        modules/* scroller.scrollTo */.OK.scrollTo("scrollToOurstory", {
            duration: 1000,
            delay: 0,
            smooth: "easeInOutQuart"
        });
    };
    var ref = (0,react.useState)(0), height = ref[0], setHeight = ref[1];
    var storyTextRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (storyTextRef.current) {
            var storyHeight = storyTextRef.current.clientHeight;
            setHeight(storyHeight);
        }
    }, [
        storyTextRef,
        height
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: (BannerMob_module_default()).bannerSection,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (BannerMob_module_default()).bannerRow,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (BannerMob_module_default()).textCol,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (BannerMob_module_default()).text,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                            children: [
                                                "Building India’s Leading ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "B2B Road Transportation Marketplace"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(A/* default */.Z, {
                                            className: (BannerMob_module_default()).meetUsBtn,
                                            onClick: scrollToSection,
                                            style: {
                                                backgroundColor: "#1053FF",
                                                color: "#fff",
                                                textAlign: "center",
                                                fontSize: "14px",
                                                padding: "10px",
                                                height: "46px",
                                                width: "130px",
                                                display: "block",
                                                marginTop: "20px",
                                                lineHeight: "28px",
                                                fontWeight: "bold",
                                                borderRadius: "5px"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    "Meet Us",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(arrowDownWhite, {
                                                        style: {
                                                            width: "14px",
                                                            height: "14px",
                                                            position: "relative",
                                                            top: "-1px",
                                                            right: "-7px",
                                                            transform: "rotate(90deg)"
                                                        }
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (BannerMob_module_default()).aboutStoryCol,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppImg["default"], {
                                    className: (BannerMob_module_default()).imgBgBox,
                                    src: "ourStoryDefault.png",
                                    objectFit: "cover",
                                    objectPosition: "center",
                                    alt: "our story",
                                    layout: "responsive",
                                    width: "379",
                                    height: "215",
                                    priority: true
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "scrollToOurstory",
                    style: {
                        paddingTop: "50px"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (BannerMob_module_default()).ourStoryWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (BannerMob_module_default()).ourStoryOuter,
                        style: {
                            height: "".concat(height, "px")
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (BannerMob_module_default()).ourStoryImg,
                                style: {
                                    filter: "blur(30px)",
                                    height: "100%"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppImg["default"], {
                                    className: classnames_default()((BannerMob_module_default()).ourStory),
                                    src: "ourStoryDefault.png",
                                    layout: "fill",
                                    objectFit: "cover",
                                    objectPosition: "center"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: storyTextRef,
                                className: (BannerMob_module_default()).ourStoryText,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "container",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            children: "Our Story"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: '"The story begins with Karan, one of our co-founders, noticing a huge problem in India’s logistics space – SMEs were struggling to transport their product! To resolve this problem and provide logistics companies with the kind of support they needed to flourish, Karan joined with Vikas, our second-cofounder, to create Epictus Solutions. This venture helped logistics businesses with GPS and transportation solutions. With Epictus’ rapid growth, the co-founders came to a realization that Indian transporters needed more than what their venture offered – they needed an extensive platform that would let them digitize all their day-to-day business operations!'
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                "And so, after trials, errors and lots of learning – Vahak was born. Today, Vahak is the largest online transport marketplace community with over",
                                                " ",
                                                (0,getTransporterFigure/* getTransporterFigure */.I)(),
                                                " Indian transporters on it's platform. In the Indian logistics space, we aim to be more than just a product – we want to revolutionize the way B2B transportation happens in India!"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "With the Vahak app, users should no longer struggle to get or provide logistics services. Logistics is the backbone of the Indian economy, and we're here to strengthen it! By providing users with the technology for booking trucks and loads online, we're bridging the gap between lorry and load businesses, and helping them serve customers better.\""
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var banner_mob_BannerMob = (BannerMob);

// EXTERNAL MODULE: ./components/aboutus/banner/banner-dest/BannerDest.module.scss
var BannerDest_module = __webpack_require__(80549);
var BannerDest_module_default = /*#__PURE__*/__webpack_require__.n(BannerDest_module);
;// CONCATENATED MODULE: ../core/dist/icons/arrowDownWhite.svg
var arrowDownWhite_defs, arrowDownWhite_path;

function arrowDownWhite_extends() { arrowDownWhite_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrowDownWhite_extends.apply(this, arguments); }



function arrowDownWhite_SvgArrowDownWhite(props) {
  return /*#__PURE__*/react.createElement("svg", arrowDownWhite_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14.828,
    viewBox: "0 0 14 14.828"
  }, props), arrowDownWhite_defs || (arrowDownWhite_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("style", null, ".arrowDownWhite_svg__arrow-right_b{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"))), arrowDownWhite_path || (arrowDownWhite_path = /*#__PURE__*/react.createElement("path", {
    className: "arrowDownWhite_svg__arrow-right_b",
    d: "M1 7.414h12M7 1.414l6 6-6 6"
  })));
}

/* harmony default export */ var icons_arrowDownWhite = (arrowDownWhite_SvgArrowDownWhite);
;// CONCATENATED MODULE: ./components/aboutus/banner/banner-dest/BannerDest.tsx








var BannerDest = function() {
    var ref = (0,react.useState)(0), state = ref[0], setState = ref[1];
    var scrollToSection = function() {
        var viewPortWidth = window.screen.availWidth;
        window.scroll({
            top: viewPortWidth,
            behavior: "smooth"
        });
    };
    (0,react.useEffect)(function() {
        window === null || window === void 0 ? void 0 : window.addEventListener("scroll", function() {
            var viewPortWidth = window.screen.availWidth;
            var scrollY = window.scrollY;
            if (viewPortWidth >= 1200) {
                setState(scrollY + 560);
            } else if (viewPortWidth >= 1300) {
                setState(scrollY + 640);
            } else if (viewPortWidth >= 1400) {
                setState(scrollY + 700);
            } else {
                setState(scrollY + 480);
            }
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: classnames_default()((BannerDest_module_default()).bannerSection, "flipAnimate"),
        style: {
            paddingLeft: state >= 1000 ? "-4%" : "0"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat(state >= 1000 ? "" : "container"),
            style: {
                height: "100%"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (BannerDest_module_default()).bannerRow,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (BannerDest_module_default()).textCol,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (BannerDest_module_default()).text,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                    children: [
                                        "Building India’s Leading",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            "data-hover": "B2B Road Transportation Marketplace",
                                            className: "indaiText",
                                            children: "B2B Road Transportation Marketplace"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(A/* default */.Z, {
                                    className: (BannerDest_module_default()).meetUsBtn,
                                    onClick: scrollToSection,
                                    style: {
                                        backgroundColor: "#1053FF",
                                        color: "#fff",
                                        textAlign: "center",
                                        fontSize: "20px",
                                        padding: "15px",
                                        height: "60px",
                                        width: "190px",
                                        display: "block",
                                        marginTop: "40px",
                                        lineHeight: "32px",
                                        fontWeight: "bold",
                                        borderRadius: "6px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            "Meet Us",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_arrowDownWhite, {
                                                style: {
                                                    width: "15px",
                                                    height: "15px",
                                                    position: "relative",
                                                    top: "-1px",
                                                    right: "-7px",
                                                    transform: "rotate(90deg)"
                                                }
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (BannerDest_module_default()).aboutStoryCol,
                    style: {
                        width: state,
                        top: state >= 1000 ? "70px" : "100px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (BannerDest_module_default()).storyImgWrap,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    position: "relative",
                                    borderRadius: state >= 1000 ? "0px" : "15px",
                                    overflow: state >= 900 ? "hidden" : undefined,
                                    // overflow: "hidden",
                                    marginLeft: state >= 900 ? "-10px" : undefined,
                                    filter: state >= 900 ? "blur(30px)" : undefined,
                                    height: state >= 1000 ? "87vh" : "75vh",
                                    translate: "height 2000",
                                    width: "100%"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppImg["default"], {
                                    className: classnames_default()((BannerDest_module_default()).imgBgBox, "rounder-full"),
                                    src: "KaranVikasDesktop.jpg",
                                    quality: 100,
                                    alt: "our story",
                                    layout: "fill",
                                    width: "700",
                                    height: "568",
                                    priority: true
                                })
                            }),
                            state >= 1000 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (BannerDest_module_default()).ourStory,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (BannerDest_module_default()).ourStoryText,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: "Our Story"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: '"The story begins with Karan, one of our co-founders, noticing a huge problem in India’s logistics space – SMEs were struggling to transport their product! To resolve this problem and provide logistics companies with the kind of support they needed to flourish, Karan joined with Vikas, our second-cofounder, to create Epictus Solutions. This venture helped logistics businesses with GPS and transportation solutions. With Epictus’ rapid growth, the co-founders came to a realization that Indian transporters needed more than what their venture offered – they needed an extensive platform that would let them digitize all their day-to-day business operations!'
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "And so, after trials, errors and lots of learning – Vahak was born. Today, Vahak is the largest online transport marketplace community with over",
                                                    " ",
                                                    (0,getTransporterFigure/* getTransporterFigure */.I)(),
                                                    " Indian transporters on it's platform. In the Indian logistics space, we aim to be more than just a product – we want to revolutionize the way B2B transportation happens in India!"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "With the Vahak app, users should no longer struggle to get or provide logistics services. Logistics is the backbone of the Indian economy, and we're here to strengthen it! By providing users with the technology for booking trucks and loads online, we're bridging the gap between lorry and load businesses, and helping them serve customers better.\""
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var banner_dest_BannerDest = (BannerDest);

;// CONCATENATED MODULE: ./components/aboutus/banner/Banner.tsx




var Banner = function(param) {
    var isMobile = param.isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(banner_mob_BannerMob, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(banner_dest_BannerDest, {})
    });
};
/* harmony default export */ var banner_Banner = (Banner);

// EXTERNAL MODULE: ./components/aboutus/we-grown-lot/WeGrownLot.module.scss
var WeGrownLot_module = __webpack_require__(69232);
var WeGrownLot_module_default = /*#__PURE__*/__webpack_require__.n(WeGrownLot_module);
;// CONCATENATED MODULE: ../core/dist/icons/top_view_truck.svg
var _style, top_view_truck_path, _path2, _path3, _linearGradient, _path4, _linearGradient2, _path5, _path6, _path7, _image, _image2, _path8, _path9, _linearGradient3, _path10, _path11, _linearGradient4, _path12, _linearGradient5, _path13, _path14, _linearGradient6, _path15, _linearGradient7, _path16, _linearGradient8, _path17, _linearGradient9, _path18, _linearGradient10, _path19, _linearGradient11, _path20, _linearGradient12, _path21, _path22, _path23, _path24, _path25, _path26, _linearGradient13, _path27, _linearGradient14, _path28, _path29, _path30, _linearGradient15, _path31;

function top_view_truck_extends() { top_view_truck_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return top_view_truck_extends.apply(this, arguments); }



function SvgTopViewTruck(props) {
  return /*#__PURE__*/react.createElement("svg", top_view_truck_extends({
    id: "top_view_truck_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 480.2 488.2",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/react.createElement("style", null, ".top_view_truck_svg__st0{fill:#0f4cf4}.top_view_truck_svg__st1{fill:#2355fc}.top_view_truck_svg__st2{fill:#f7941e}")), top_view_truck_path || (top_view_truck_path = /*#__PURE__*/react.createElement("path", {
    className: "top_view_truck_svg__st0",
    d: "M183.6 141.5c-1-5.1 1.6-20.7 1.6-20.7 0-14.7 24.2-21.5 37.6-21.5h34.5c13.4 0 37.6 6.7 37.6 21.5 0 0 2.6 15.6 1.6 20.7-.9 4.9-2 32.1-2 32.1h-109c.1.1-.9-27-1.9-32.1z"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    className: "top_view_truck_svg__st1",
    d: "M257.1 99.4h-34c-13.2 0-37.9 6.5-37.9 20.8v2c0-5 1.8-8.6 4.8-11.1 5.7-5.8 15.7-8.6 27.2-8.6h45.7c11.5 0 21.6 2.8 27.2 8.6 3.1 2.5 4.8 6.1 4.8 11.1v-2c.1-14.3-24.7-20.8-37.8-20.8z"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    className: "top_view_truck_svg__st2",
    d: "M289.6 123.3c-.5-.1-.9-.5-.9-1.1 0-2.1-.8-4.1-2.2-5.6-.4-.4-.4-1-.1-1.4.3-.4 1-.4 1.5.1 1.7 1.9 2.7 4.3 2.7 6.8 0 .8-.5 1.3-1 1.2zM190.6 123.3c.5-.1.9-.5.9-1.1 0-2.1.8-4.1 2.2-5.6.4-.4.4-1 .1-1.4-.3-.4-1-.4-1.5.1-1.7 1.9-2.7 4.3-2.7 6.8 0 .8.5 1.3 1 1.2z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/react.createElement("linearGradient", {
    id: "top_view_truck_svg__SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 273.774,
    y1: 110.688,
    x2: 287.315,
    y2: 110.688
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0,
    stopColor: "#f7f7f7"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#dbdbdb"
  }))), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M274 106.4s-.7-.7.5-.8c1.2-.1 7.6.3 11 5.1 3.4 4.9.9 5 .9 5l-12.4-9.3z",
    fill: "url(#top_view_truck_svg__SVGID_1_)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/react.createElement("linearGradient", {
    id: "top_view_truck_svg__SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.688,
    y1: 110.688,
    x2: 205.636,
    y2: 110.688
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0,
    stopColor: "#f7f7f7"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#dbdbdb"
  }))), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
    d: "M206.3 106.4s.7-.7-.5-.8c-1.2-.1-7.6.3-11 5.1-3.4 4.9-.9 5-.9 5l12.4-9.3z",
    fill: "url(#top_view_truck_svg__SVGID_2_)"
  })), _path6 || (_path6 = /*#__PURE__*/react.createElement("path", {
    className: "top_view_truck_svg__st1",
    d: "M185.1 139.9c-.4-5 6.1-19.7 6.1-19.7 4.3-13.8 18.6-14.9 26.1-14.9H263c7.4 0 21.7 1.1 26.1 14.9 0 0 6.4 14.7 6.1 19.7-.3 5-4.2 20.2-4.2 20.2l-97.8-.7c-.1-.1-7.7-14.3-8.1-19.5z"
  })), _path7 || (_path7 = /*#__PURE__*/react.createElement("path", {
    className: "top_view_truck_svg__st1",
    d: "M272.4 139.6c-10.1 11.6-54.6 11.6-64.7 0-4.9-5.6 12.2-33.3 12.2-33.3h40.3s17.1 27.7 12.2 33.3z"
  })), _image || (_image = /*#__PURE__*/react.createElement("image", {
    width: 75,
    height: 137,
    xlinkHref: "72934AC4A5C0E5C2.png",
    transform: "matrix(.24 0 0 .24 265.626 108.56)",
    overflow: "visible"
  })), _image2 || (_image2 = /*#__PURE__*/react.createElement("image", {
    width: 75,
    height: 137,
    xlinkHref: "72934AC4A5C0E5C6.png",
    transform: "matrix(.24 0 0 .24 196.506 108.56)",
    overflow: "visible"
  })), _path8 || (_path8 = /*#__PURE__*/react.createElement("path", {
    className: "top_view_truck_svg__st1",
    d: "M190.6 209.4h98.8s5.2-3.9 5.2-5.7v-30c0-6.6-3.7-13.6-3.7-13.6s-9.6-6.6-50.8-6.4c-27.7-.1-43.4 4.3-50.3 7.1-3.3 1.4-4.2 7.7-4.2 12.9v30c0 4.2 5 5.7 5 5.7z"
  })), _path9 || (_path9 = /*#__PURE__*/react.createElement("path", {
    className: "top_view_truck_svg__st1",
    d: "M195.6 209.4s-3.4-9.6-3.4-25.2c0-10.8 3.4-24.1 3.4-24.1 3.1-1.1 23.8-5.1 44.5-5.1s41.3 3.6 44.5 4.8c0 0 3.4 12.8 3.4 24.5 0 16.4-3.4 25.2-3.4 25.2h-89z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/react.createElement("linearGradient", {
    id: "top_view_truck_svg__SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 259.515,
    y1: 81.759,
    x2: 272.138,
    y2: 106.199,
    gradientTransform: "rotate(1.403 -2404.476 1367.594)"
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0,
    stopColor: "#363b39"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#1b1c1c"
  }))), _path10 || (_path10 = /*#__PURE__*/react.createElement("path", {
    d: "M290.6 143.6s5.9 1.3 5.9 6.1c0 4.9-6.3 14.6-6.2 8.3 0-6.1-.3-12.5.3-14.4z",
    fill: "url(#top_view_truck_svg__SVGID_3_)"
  })), _path11 || (_path11 = /*#__PURE__*/react.createElement("path", {
    className: "top_view_truck_svg__st0",
    d: "M310.9 154.4c-1.3-1.7-13.2-5.2-13.2-5.2-2.3-.7-3.2 1.3-3.4 3l17 5c.3-.9.3-1.9-.4-2.8z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/react.createElement("linearGradient", {
    id: "top_view_truck_svg__SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 294.18,
    y1: 155.141,
    x2: 311.498,
    y2: 155.141
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0,
    stopColor: "#363b39"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#1b1c1c"
  }))), _path12 || (_path12 = /*#__PURE__*/react.createElement("path", {
    d: "M294.3 152.1c-.2 1.1-.1 2.1-.1 2.1l16.7 4s.3-.5.4-1.1l-17-5z",
    fill: "url(#top_view_truck_svg__SVGID_4_)"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/react.createElement("linearGradient", {
    id: "top_view_truck_svg__SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 508.678,
    y1: 75.828,
    x2: 521.3,
    y2: 100.266,
    gradientTransform: "scale(-1 1) rotate(1.364 -2770.159 -29276.4)"
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0,
    stopColor: "#363b39"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#1b1c1c"
  }))), _path13 || (_path13 = /*#__PURE__*/react.createElement("path", {
    d: "M189.6 143.6s-5.9 1.3-5.9 6.1c0 4.9 6.3 14.6 6.2 8.3 0-6.1.2-12.5-.3-14.4z",
    fill: "url(#top_view_truck_svg__SVGID_5_)"
  })), _path14 || (_path14 = /*#__PURE__*/react.createElement("path", {
    className: "top_view_truck_svg__st0",
    d: "M169.2 154.4c1.3-1.7 13.2-5.2 13.2-5.2 2.3-.7 3.1 1.3 3.4 3l-17 5c-.2-.9-.3-1.9.4-2.8z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/react.createElement("linearGradient", {
    id: "top_view_truck_svg__SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 543.411,
    y1: 155.141,
    x2: 560.726,
    y2: 155.141,
    gradientTransform: "matrix(-1 0 0 1 729.39 0)"
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0,
    stopColor: "#363b39"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#1b1c1c"
  }))), _path15 || (_path15 = /*#__PURE__*/react.createElement("path", {
    d: "M185.8 152.1c.2 1.1.1 2.1.1 2.1l-16.7 4s-.3-.5-.4-1.1l17-5z",
    fill: "url(#top_view_truck_svg__SVGID_6_)"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/react.createElement("linearGradient", {
    id: "top_view_truck_svg__SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 219.924,
    y1: 105.603,
    x2: 260.242,
    y2: 105.603
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0,
    stopColor: "#363b39"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#0c0d0d"
  }))), _path16 || (_path16 = /*#__PURE__*/react.createElement("path", {
    fill: "url(#top_view_truck_svg__SVGID_7_)",
    d: "M260.2 106.3h-40.3l2.5-1.4h35.4z"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/react.createElement("linearGradient", {
    id: "top_view_truck_svg__SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.315,
    y1: 173.68,
    x2: 311.683,
    y2: 222.796
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0,
    stopColor: "#363b39"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#1b1c1c"
  }))), _path17 || (_path17 = /*#__PURE__*/react.createElement("path", {
    d: "M289.6 203.6l5-5.2v-.7-24s.1-2.9.3-7l-5.4 4.9c.1-.1 2.6 15.2.1 32z",
    fill: "url(#top_view_truck_svg__SVGID_8_)"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/react.createElement("linearGradient", {
    id: "top_view_truck_svg__SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 288.185,
    y1: 183.547,
    x2: 304.865,
    y2: 215.842
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0,
    stopColor: "#3b3b3b"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1
  }))), _path18 || (_path18 = /*#__PURE__*/react.createElement("path", {
    d: "M294.6 198.4v-19.9c-1.3 1-2.7 2.1-4.1 3.2.3 5.9.3 13.7-1 22l5.1-5.3z",
    fill: "url(#top_view_truck_svg__SVGID_9_)"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/react.createElement("linearGradient", {
    id: "top_view_truck_svg__SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.514,
    y1: 172.197,
    x2: 210.505,
    y2: 228.328
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0,
    stopColor: "#363b39"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#1b1c1c"
  }))), _path19 || (_path19 = /*#__PURE__*/react.createElement("path", {
    d: "M190.6 203.6c-2.6-16.8 0-32.1 0-32.1l-5.3-4.3c.2 3.8.3 6.4.3 6.4v24.7l5 5.3z",
    fill: "url(#top_view_truck_svg__SVGID_10_)"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/react.createElement("linearGradient", {
    id: "top_view_truck_svg__SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 177.071,
    y1: 182.741,
    x2: 194.563,
    y2: 195.952
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#3b3b3b"
  }))), _path20 || (_path20 = /*#__PURE__*/react.createElement("path", {
    d: "M185.6 198.4v-19.9c1.3 1 2.7 2.1 4.1 3.2-.3 5.9-.3 13.7 1 22l-5.1-5.3z",
    fill: "url(#top_view_truck_svg__SVGID_11_)"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/react.createElement("linearGradient", {
    id: "top_view_truck_svg__SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 190.619,
    y1: 210.921,
    x2: 289.551,
    y2: 210.921
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0,
    stopColor: "#363b39"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#0c0d0d"
  }))), _path21 || (_path21 = /*#__PURE__*/react.createElement("path", {
    fill: "url(#top_view_truck_svg__SVGID_12_)",
    d: "M190.6 209.4h98.9v3.1h-98.9z"
  })), _path22 || (_path22 = /*#__PURE__*/react.createElement("path", {
    d: "M280.4 138.4c-14.3-5.9-30.2-9-46.8-8.6v-2c16.9-.4 33 2.7 47.5 8.7-.2.7-.4 1.3-.7 1.9z"
  })), _path23 || (_path23 = /*#__PURE__*/react.createElement("path", {
    d: "M250.9 130c0 1.2-5.2 2.1-11.5 2.1-6.4 0-11.5-.9-11.5-2.1 0-1.2 5.2-2.1 11.5-2.1s11.5.9 11.5 2.1z"
  })), _path24 || (_path24 = /*#__PURE__*/react.createElement("path", {
    d: "M294.4 195.1c.6 0 1-.5 1-1.1v-8.9c0-.6-.5-1.1-1-1.1v11.1z",
    fill: "#e3e3e3"
  })), _path25 || (_path25 = /*#__PURE__*/react.createElement("path", {
    d: "M185.6 195.1c-.6 0-1-.5-1-1.1v-8.9c0-.6.5-1.1 1-1.1v11.1z",
    fill: "#c9c9c9"
  })), _path26 || (_path26 = /*#__PURE__*/react.createElement("path", {
    d: "M240.1 154.3c-15.9 0-45.6 4.7-45.6 4.7s-3.3-18.7-3.7-22.1l-.1-.8.7-.2c16.8-5.3 33.2-7.9 50.3-7.9 14.4 0 29.7 1.8 46.8 5.5l.7.2v.7c0 9.6-3.6 24.6-3.6 24.6s-29.6-4.7-45.5-4.7z"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/react.createElement("linearGradient", {
    id: "top_view_truck_svg__SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 191.712,
    y1: 143.493,
    x2: 288.397,
    y2: 143.493
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0,
    stopColor: "#363b39"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#0c0d0d"
  }))), _path27 || (_path27 = /*#__PURE__*/react.createElement("path", {
    d: "M286 158.1c-30.4-6.5-60.3-6.9-90.8-.3-1.2-7.9-2.6-13.5-3.5-21.1 31.2-9.9 60.7-10.2 96.7-2.3 0 9.6-2 23.8-2.4 23.7z",
    fill: "url(#top_view_truck_svg__SVGID_13_)"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/react.createElement("linearGradient", {
    id: "top_view_truck_svg__SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 207.397,
    y1: 142.645,
    x2: 274.276,
    y2: 142.645
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0,
    stopColor: "#3b3b3b"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1
  }))), _path28 || (_path28 = /*#__PURE__*/react.createElement("path", {
    d: "M211.3 155.2c19.5-2.5 39.5-2.5 59 .2l3.9-23.3c-22.1-2.9-44.7-3-66.9-.2l4 23.3z",
    fill: "url(#top_view_truck_svg__SVGID_14_)"
  })), _path29 || (_path29 = /*#__PURE__*/react.createElement("path", {
    className: "top_view_truck_svg__st0",
    d: "M302.6 425.5h-125c-2 0-3.7-1.7-3.7-3.7V216.1c0-2 1.7-3.7 3.7-3.7h125c2 0 3.7 1.7 3.7 3.7v205.7c0 2.1-1.7 3.7-3.7 3.7z"
  })), _path30 || (_path30 = /*#__PURE__*/react.createElement("path", {
    className: "top_view_truck_svg__st1",
    d: "M183.1 221.7H297v194.6H183.1z"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/react.createElement("linearGradient", {
    id: "top_view_truck_svg__SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 184.925,
    y1: 323.441,
    x2: 251.594,
    y2: 323.441
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0,
    stopColor: "#787878"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 0.996
  }))), _path31 || (_path31 = /*#__PURE__*/react.createElement("path", {
    d: "M223.9 266.9c-2.2-26.6-22.8-34.5-40.8-36.3v185.7h62.6c10.7-39.3-12.7-55.6-25.3-75-13.9-21.5 7.5-26.5 3.5-74.4z",
    fill: "url(#top_view_truck_svg__SVGID_15_)"
  })));
}

/* harmony default export */ var top_view_truck = (SvgTopViewTruck);
;// CONCATENATED MODULE: ../core/dist/icons/location_blue.svg
var location_blue_path;

function location_blue_extends() { location_blue_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return location_blue_extends.apply(this, arguments); }



function SvgLocationBlue(props) {
  return /*#__PURE__*/react.createElement("svg", location_blue_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 18,
    fill: "none",
    viewBox: "0 0 12 18"
  }, props), location_blue_path || (location_blue_path = /*#__PURE__*/react.createElement("path", {
    fill: "#2355fc",
    d: "M11.166 3.082C10.107 1.197 8.226.045 6.134.002a7.991 7.991 0 00-.268-.001C3.774.044 1.893 1.196.833 3.081a6.442 6.442 0 00-.079 6.193l4.328 8.17.006.01a1.035 1.035 0 001.824.001l.006-.01 4.328-8.17a6.44 6.44 0 00-.08-6.193zM6 8.156c-1.353 0-2.454-1.135-2.454-2.531 0-1.396 1.1-2.531 2.454-2.531 1.353 0 2.454 1.135 2.454 2.531 0 1.396-1.1 2.531-2.454 2.531z"
  })));
}

/* harmony default export */ var location_blue = (SvgLocationBlue);
// EXTERNAL MODULE: ../core/dist/hooks/useIntersect.js
var useIntersect = __webpack_require__(86369);
// EXTERNAL MODULE: ../core/dist/methods/getDownloadsFigure.js
var getDownloadsFigure = __webpack_require__(19314);
// EXTERNAL MODULE: ../core/dist/constants/platformStats.js
var platformStats = __webpack_require__(28230);
;// CONCATENATED MODULE: ./components/aboutus/we-grown-lot/WeGrownLot.tsx











var WeGrownLot = function(param) {
    var isMobile = param.isMobile;
    var ref = (0,react.useState)(false), refMap = ref[0], setRefMap = ref[1];
    var ref1 = (0,react.useState)(0), dotCount = ref1[0], setDotCount = ref1[1];
    var ref2 = (0,useIntersect/* useIntersect */.U)({
        rootMargin: isMobile ? "-60px" : "74px",
        threshold: 0
    }), interSectionObjMap = ref2.entry, mapRefCallback = ref2.setNode;
    (0,react.useEffect)(function() {
        if ((interSectionObjMap === null || interSectionObjMap === void 0 ? void 0 : interSectionObjMap.intersectionRatio) === 0) {
            setRefMap(false);
        } else {
            setRefMap(true);
            var interval = setInterval(function() {
                if (dotCount < 90) {
                    setDotCount(function(prevCount) {
                        return prevCount + 1;
                    });
                } else {
                    clearInterval(interval);
                }
            }, 50);
            return function() {
                clearInterval(interval);
            };
        }
    }, [
        interSectionObjMap,
        dotCount
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: classnames_default()((WeGrownLot_module_default()).weGrownlotSection, "flipAnimate", refMap ? (WeGrownLot_module_default()).curveAnim : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (WeGrownLot_module_default()).heading,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        children: [
                            "We’ve grown a lot since",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                "data-hover": "We Started",
                                className: "indaiText",
                                children: "We Started"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (WeGrownLot_module_default()).indiaMaprow,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (WeGrownLot_module_default()).indiaMapCol,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (WeGrownLot_module_default()).imgBox,
                                ref: mapRefCallback,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AppImg["default"], {
                                        src: "indiaMap.aeffd640-Mobile.png",
                                        alt: "our reach",
                                        width: isMobile ? "330" : "540",
                                        height: isMobile ? "353" : "578",
                                        layout: "responsive"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).lorryIcon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(top_view_truck, {
                                            width: "60",
                                            height: "61"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (WeGrownLot_module_default()).locatorPin,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(location_blue, {
                                            width: "64",
                                            height: "64"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (WeGrownLot_module_default()).locatorPin,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(location_blue, {
                                            width: "64",
                                            height: "64"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (WeGrownLot_module_default()).locatorPin,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(location_blue, {
                                            width: "64",
                                            height: "64"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (WeGrownLot_module_default()).locatorPin,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(location_blue, {
                                            width: "64",
                                            height: "64"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (WeGrownLot_module_default()).locatorPin,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(location_blue, {
                                            width: "64",
                                            height: "64"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (WeGrownLot_module_default()).locatorPin,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(location_blue, {
                                            width: "64",
                                            height: "64"
                                        })
                                    }),
                                    dotCount > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 2 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 3 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 4 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 5 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 6 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 7 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 8 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 9 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 10 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 11 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 12 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 13 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 14 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 15 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 16 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 17 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 18 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 19 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 20 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 21 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 22 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 23 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 24 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 25 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 26 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 27 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 28 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 29 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 30 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 31 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 32 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 32 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 33 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 34 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 36 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 37 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 38 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 39 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 40 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 41 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 42 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 43 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 44 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 45 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 46 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 47 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 48 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 49 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 50 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 50 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 51 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 52 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 53 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 54 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 55 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 56 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 57 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 58 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 59 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 60 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 61 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 62 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 63 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 64 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 65 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 66 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 67 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 68 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 69 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 70 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 71 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 72 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 73 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 73 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 74 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 75 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 76 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 77 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : "",
                                    dotCount > 78 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WeGrownLot_module_default()).dot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                    }) : ""
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (WeGrownLot_module_default()).grownDtlCol,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (WeGrownLot_module_default()).grownBoxes,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (WeGrownLot_module_default()).grownBox,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: platformStats/* PLATFORM_STATS.cities.label */.s.cities.label
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Cities Across India"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (WeGrownLot_module_default()).grownBox,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: platformStats/* PLATFORM_STATS.bookings.lakhs */.s.bookings.lakhs
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Bookings done"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (WeGrownLot_module_default()).grownBox,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: (0,getTransporterFigure/* getTransporterFigure */.I)(getTransporterFigure/* getTransporterFigureTypes.LAKHS */.Y.LAKHS)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Transporters Network"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (WeGrownLot_module_default()).grownBox,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: (0,getDownloadsFigure/* getDownloadsFigure */.u)(getDownloadsFigure/* getDownloadsFigureTypes.MILLIONS */.d.MILLIONS)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Downloads"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (WeGrownLot_module_default()).grownBox,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: "8+"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Local Languages"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var we_grown_lot_WeGrownLot = (WeGrownLot);

// EXTERNAL MODULE: ./components/aboutus/join-our-fam/JoinOurFam.module.scss
var JoinOurFam_module = __webpack_require__(37365);
var JoinOurFam_module_default = /*#__PURE__*/__webpack_require__.n(JoinOurFam_module);
// EXTERNAL MODULE: ../core/dist/icons/ArrowRightBlack.svg
var ArrowRightBlack = __webpack_require__(85642);
;// CONCATENATED MODULE: ./components/aboutus/join-our-fam/JoinOurFam.tsx







var JoinOurFam = function(param) {
    var isMobile = param.isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (JoinOurFam_module_default()).joinOurFamSection,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (JoinOurFam_module_default()).ourFamBGImg,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppImg["default"], {
                    src: "join-our-fam.JPG",
                    layout: "fill",
                    objectPosition: "center",
                    objectFit: "cover"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("container", (JoinOurFam_module_default()).textBox),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        children: "Do you want to tag along?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "We are on a mission to empower small and medium size logistics businesses in India to dream big."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(A/* default */.Z, {
                        href: "/careers",
                        className: (JoinOurFam_module_default()).joinFam,
                        children: [
                            "Join Our Fam",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightBlack/* default */.Z, {
                                style: {
                                    width: isMobile ? "12px" : "16px",
                                    height: isMobile ? "12px" : "16px",
                                    position: "relative",
                                    top: "0",
                                    right: "-5px"
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var join_our_fam_JoinOurFam = (JoinOurFam);

// EXTERNAL MODULE: ./components/aboutus/leadership-team/LeadershipTeam.module.scss
var LeadershipTeam_module = __webpack_require__(59095);
var LeadershipTeam_module_default = /*#__PURE__*/__webpack_require__.n(LeadershipTeam_module);
// EXTERNAL MODULE: ../core/dist/components/onscrollfadein/OnScrollFadeIn.js + 1 modules
var OnScrollFadeIn = __webpack_require__(71069);
;// CONCATENATED MODULE: ../core/dist/icons/linkedinIconWhite.svg
var linkedinIconWhite_path;

function linkedinIconWhite_extends() { linkedinIconWhite_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return linkedinIconWhite_extends.apply(this, arguments); }



function SvgLinkedinIconWhite(props) {
  return /*#__PURE__*/react.createElement("svg", linkedinIconWhite_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26"
  }, props), linkedinIconWhite_path || (linkedinIconWhite_path = /*#__PURE__*/react.createElement("path", {
    d: "M23.4 0H2.6A2.608 2.608 0 000 2.6v20.8A2.608 2.608 0 002.6 26h20.8a2.608 2.608 0 002.6-2.6V2.6A2.608 2.608 0 0023.4 0zM7.8 22.1H3.9V10.4h3.9zM5.85 8.19a2.34 2.34 0 112.34-2.34 2.33 2.33 0 01-2.34 2.34zM22.1 22.1h-3.9v-6.89a1.95 1.95 0 00-3.9 0v6.89h-3.9V10.4h3.9v1.56a4.2 4.2 0 013.25-1.82 4.606 4.606 0 014.55 4.55z",
    fill: "#202124",
    opacity: 0.2
  })));
}

/* harmony default export */ var linkedinIconWhite = (SvgLinkedinIconWhite);
;// CONCATENATED MODULE: ./components/aboutus/leadership-team/LeadershipTeam.tsx








var leadershipTeam = [
    {
        id: 0,
        profileImgLarge: "KaranDesktop.jpg",
        profileImgSmall: "KaranDesktop.jpg",
        name: "Karan Shaha",
        jobTitle: "Co-founder & CEO",
        linkedinLink: "https://www.linkedin.com/in/karan-shaha-aba4b9101/"
    },
    {
        id: 1,
        profileImgLarge: "Vikas.png",
        profileImgSmall: "Vikas-Mobile.png",
        name: "Vikas Chandrawat",
        jobTitle: "Co-founder & CPO",
        linkedinLink: "https://www.linkedin.com/in/vikas-chandrawat/"
    },
    {
        id: 2,
        profileImgLarge: "vinay-pic-website.jpeg",
        profileImgSmall: "vinay-pic-website.jpeg",
        name: "Vinay Chitlangia",
        jobTitle: "VP - Technology",
        linkedinLink: "https://www.linkedin.com/in/vchitlangia"
    },
    {
        id: 3,
        profileImgLarge: "vineet-pic-website.jpeg",
        profileImgSmall: "vineet-pic-website.jpeg",
        name: "Vineet Sinha",
        jobTitle: "Head of Data Science",
        linkedinLink: "https://www.linkedin.com/in/vineet-sinha9"
    },
    {
        id: 4,
        profileImg: "Prashant.png",
        profileImgLarge: "Prashant-Desktop.png",
        profileImgSmall: "Prashant-Mobile.png",
        name: "Prashaant Mahagaonkar",
        jobTitle: "Chief People Officer",
        linkedinLink: "https://www.linkedin.com/in/prashaant-mahagaonkar-01333319/"
    }
];
var LeadershipTeam = function(param) {
    var isMobile = param.isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: classnames_default()((LeadershipTeam_module_default()).leadershipTeamSection, "flipAnimate"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (LeadershipTeam_module_default()).heading,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        children: [
                            "Meet our",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                "data-hover": "Leadership Team",
                                className: "indaiText",
                                children: "Leadership Team"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (LeadershipTeam_module_default()).ourTeamRow,
                    children: leadershipTeam.map(function(leadership) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (LeadershipTeam_module_default()).ourTeamCol,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OnScrollFadeIn/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (LeadershipTeam_module_default()).ourTeamCard,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(A/* default */.Z, {
                                        openInNewTab: true,
                                        href: leadership.linkedinLink,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (LeadershipTeam_module_default()).imageBox,
                                                style: {
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppImg["default"], {
                                                    src: leadership.profileImgLarge,
                                                    alt: leadership.name,
                                                    width: isMobile ? "365" : "360",
                                                    height: isMobile ? "340" : "440",
                                                    layout: "responsive",
                                                    objectFit: "cover",
                                                    objectPosition: "top"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (LeadershipTeam_module_default()).textBox,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (LeadershipTeam_module_default()).nameTitle,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                children: leadership.name
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: leadership.jobTitle
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (LeadershipTeam_module_default()).linkedIn,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(linkedinIconWhite, {
                                                            width: "26",
                                                            height: "26"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        }, leadership.id);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var leadership_team_LeadershipTeam = (LeadershipTeam);

// EXTERNAL MODULE: ./components/aboutus/advisors-investers/AdvisorsInvesters.module.scss
var AdvisorsInvesters_module = __webpack_require__(4261);
var AdvisorsInvesters_module_default = /*#__PURE__*/__webpack_require__.n(AdvisorsInvesters_module);
;// CONCATENATED MODULE: ../core/dist/icons/external-link.svg
var external_link_path;

function external_link_extends() { external_link_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return external_link_extends.apply(this, arguments); }



function SvgExternalLink(props) {
  return /*#__PURE__*/react.createElement("svg", external_link_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), external_link_path || (external_link_path = /*#__PURE__*/react.createElement("path", {
    d: "M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6M15 3h6v6M10 14L21 3",
    stroke: "#C8C9C9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

/* harmony default export */ var external_link = (SvgExternalLink);
;// CONCATENATED MODULE: ./components/aboutus/advisors-investers/AdvisorsInvesters.tsx



// Style

// Icons


// Component



var advisorsInvesters = [
    {
        id: 1,
        profileImgLarge: "leo_capital.png",
        profileImgSmall: "leo_capital.png",
        name: "Leo Capital",
        jobTitle: "Tech VC",
        linkedinLink: "https://www.linkedin.com/company/leodotcapital/"
    },
    {
        id: 2,
        profileImgLarge: "Amit.png",
        profileImgSmall: "Amit.png",
        name: "Amit Gupta",
        jobTitle: "Founder, Yulu Bikes",
        linkedinLink: "https://www.linkedin.com/in/amitgupta007/"
    },
    {
        id: 3,
        profileImgLarge: "Abishek.png",
        profileImgSmall: "Abishek.png",
        name: "Abhishek Goyal",
        jobTitle: "Founder, Tracxn",
        linkedinLink: "https://www.linkedin.com/in/abhishekgoyal/"
    },
    {
        id: 4,
        profileImgLarge: "Ramakant.png",
        profileImgSmall: "Ramakant.png",
        name: "Ramakant Sharma",
        jobTitle: "Founder, LivSpace",
        linkedinLink: "https://www.linkedin.com/in/sharmaramakant/"
    },
    {
        id: 5,
        profileImgLarge: "Harsh.png",
        profileImgSmall: "Harsh.png",
        name: "Harsh Pokharna",
        jobTitle: "Founder, OkCredit",
        linkedinLink: "https://www.linkedin.com/in/harsh-pokharna/"
    },
    {
        id: 6,
        profileImgLarge: "unnamed_02-Desktop.png",
        profileImgSmall: "unnamed_02-Desktop.png",
        name: "Archana Priyadarshini",
        jobTitle: "Partner, PointOne Capital",
        linkedinLink: "https://www.linkedin.com/in/archana-priyadarshini-5477071/"
    },
    {
        id: 7,
        profileImgLarge: "Logo-RTP-Global.png",
        name: "RTP Global",
        jobTitle: "VC",
        websiteLink: "https://rtp.vc/"
    },
    {
        id: 8,
        profileImgLarge: "uxor-capital-v1.png",
        name: "Luxor Capital",
        jobTitle: "VC",
        websiteLink: "https://luxorcap.com/"
    },
    {
        id: 9,
        profileImgLarge: "titan-capital-v1.png",
        name: "Titan Capital",
        jobTitle: "VC",
        websiteLink: "https://www.titancapital.vc/"
    },
    {
        id: 10,
        profileImgLarge: "kunal-shah.png",
        name: "Kunal Shah",
        jobTitle: "Founder of Cred, Freecharge",
        linkedinLink: "https://www.linkedin.com/in/kunalshah1"
    },
    {
        id: 11,
        profileImgLarge: "jitendra-gupta.png",
        name: "Jitendra Gupta",
        jobTitle: "Founder of Jupiter",
        linkedinLink: "https://www.linkedin.com/in/guptajiten"
    },
    {
        id: 12,
        profileImgLarge: "harsimarbir-singh.png",
        name: "Harsimarbir Singh",
        jobTitle: "Founder of Prystine Care",
        linkedinLink: "https://www.linkedin.com/in/harsimarbirsingh"
    },
    {
        id: 13,
        profileImgLarge: "ravish-naresh.png",
        name: "Ravish Naresh",
        jobTitle: "Founder of Khatabook",
        linkedinLink: "https://www.linkedin.com/in/ravish-naresh-72543359"
    },
    {
        id: 14,
        profileImgLarge: "amrish-rau.png",
        name: "Amrish Rau",
        jobTitle: "CEO of PineLabs",
        linkedinLink: "https://www.linkedin.com/in/amrish-rau-4158339"
    },
    {
        id: 15,
        profileImgLarge: "vidit-aatrey.png",
        name: "Vidit Aatrey",
        jobTitle: "Founder of Meesho",
        linkedinLink: "https://www.linkedin.com/in/vidit-aatrey-a3639120"
    },
    {
        id: 16,
        profileImgLarge: "sanjeev-barnwal.png",
        name: "Sanjeev Barnwal",
        jobTitle: "Founder of Meesho",
        linkedinLink: "https://www.linkedin.com/in/sanjeev-barnwal-4099341b"
    },
    {
        id: 17,
        profileImgLarge: "nexus-venture_partners-v1.png",
        name: "Nexus Venture Partners",
        jobTitle: "VC",
        websiteLink: "https://nexusvp.com/"
    },
    {
        id: 18,
        profileImgLarge: "foundamental-v1.png",
        name: "Foundamental",
        jobTitle: "VC",
        websiteLink: "https://foundamental.com/"
    },
    {
        id: 19,
        profileImgLarge: "iseed-ventures-v1.png",
        name: "iseed",
        jobTitle: "VC",
        websiteLink: "https://www.iseed.vc/home"
    },
    {
        id: 20,
        profileImgLarge: "farid-ahsan.png",
        name: "Farid Ahsan",
        jobTitle: "Founder of Sharechat",
        linkedinLink: "https://www.linkedin.com/in/faridahsan"
    },
    {
        id: 21,
        profileImgLarge: "work-capital-v1.png",
        name: "Work10M",
        jobTitle: "VC",
        websiteLink: "https://theworkcapital.com/"
    }
];
var AdvisorsInvesters = function(param) {
    var isMobile = param.isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: classnames_default()((AdvisorsInvesters_module_default()).advisorsInvestorsSection, "flipAnimate"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (AdvisorsInvesters_module_default()).heading,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        children: [
                            "Meet our",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                "data-hover": "Advisors & Investors",
                                className: "indaiText",
                                children: "Advisors & Investors"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (AdvisorsInvesters_module_default()).ourTeamRow,
                    children: advisorsInvesters.map(function(advrInvest) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (AdvisorsInvesters_module_default()).ourTeamCol,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OnScrollFadeIn/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (AdvisorsInvesters_module_default()).ourTeamCard,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(A/* default */.Z, {
                                        openInNewTab: true,
                                        href: advrInvest.linkedinLink ? advrInvest.linkedinLink : advrInvest.websiteLink,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (AdvisorsInvesters_module_default()).imageBox,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppImg["default"], {
                                                    src: advrInvest.profileImgLarge,
                                                    alt: advrInvest.name,
                                                    width: isMobile ? "175" : "265",
                                                    height: isMobile ? "200" : "300",
                                                    layout: "responsive",
                                                    quality: 80
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (AdvisorsInvesters_module_default()).textBox,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (AdvisorsInvesters_module_default()).nameTitle,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                children: advrInvest.name
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: advrInvest.jobTitle
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (AdvisorsInvesters_module_default()).linkedIn,
                                                        children: advrInvest.linkedinLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)(linkedinIconWhite, {
                                                            width: "26",
                                                            height: "26"
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(external_link, {
                                                            width: "26",
                                                            height: "26"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        }, advrInvest.id);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var advisors_investers_AdvisorsInvesters = (AdvisorsInvesters);

// EXTERNAL MODULE: ./components/common/page-meta-tags/PageMetaTags.tsx
var PageMetaTags = __webpack_require__(96696);
;// CONCATENATED MODULE: ./components/aboutus/About-us.tsx






// import OurJourney from "../aboutus/our-journey/OurJourney";



var ABOUT_US_DESCRIPTION = "Vahak is an online lorry and load booking platform that helps small and medium transport companies. Logistic companies can create an online brand for their business.";
function AboutUs(param) {
    var isMobile = param.isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMetaTags/* default */.Z, {
                title: "Vahak - About Us",
                description: ABOUT_US_DESCRIPTION,
                keywords: "truck transportation services,hire a truck driver for moving, transport directory,truck driving jobs, online truck booking, vahak, vahak app",
                canonicalUrl: "https://www.vahak.in/about-us",
                ogUrl: "https://www.vahak.in/about-us",
                ogImgSrc: "https://d1rgemtytdlz2g.cloudfront.net/web_og_image_jan_22.png",
                ogImgAltText: ABOUT_US_DESCRIPTION,
                schemaOrgJsonUrl: "/about-us",
                includeDefaultSchema: false,
                schemaType: "WebPage"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: classnames_default()((Aboutus_module_default()).aboutusMainPage),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(banner_Banner, {
                        isMobile: isMobile
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(we_grown_lot_WeGrownLot, {
                        isMobile: isMobile
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(leadership_team_LeadershipTeam, {
                        isMobile: isMobile
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(advisors_investers_AdvisorsInvesters, {
                        isMobile: isMobile
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(join_our_fam_JoinOurFam, {
                        isMobile: isMobile
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 96696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _seo_header_PageSeo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83347);
/* harmony import */ var _methods_pageSeo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61706);
/* harmony import */ var _vahak_core_dist_constants_platformStats__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28230);






var getCityMetaDescription = function(cityName) {
    return "Book ".concat(_vahak_core_dist_constants_platformStats__WEBPACK_IMPORTED_MODULE_5__/* .PLATFORM_STATS.liveLoadsAndLorries.label */ .s.liveLoadsAndLorries.label, " loads and lorries in ").concat(cityName, "! Vahak is the #1 platform for ").concat(cityName, " transport services. Join India's largest transporter network today for free.");
};
/**
 * Registers page SEO with the global SeoProvider.
 * Rendering is handled by GlobalSeoHead in _app — route defaults live in methods/pageSeo.ts.
 */ var PageMetaTags = function(param) {
    var cityName = param.cityName, titleProp = param.title, descriptionProp = param.description, _keywords = param.keywords, keywords = _keywords === void 0 ? "" : _keywords, asPath = param.asPath, locale = param.locale, localeNeutralPath = param.localeNeutralPath, hreflangLocales = param.hreflangLocales, canonicalUrlProp = param.canonicalUrl, ogUrl = param.ogUrl, ogDescription = param.ogDescription, _ogImgSrc = param.ogImgSrc, ogImgSrc = _ogImgSrc === void 0 ? (0,_methods_pageSeo__WEBPACK_IMPORTED_MODULE_4__/* .getDefaultOgImage */ .av)() : _ogImgSrc, ogImgAltTextProp = param.ogImgAltText, ogType = param.ogType, ogSiteName = param.ogSiteName, schema = param.schema, schemaOrgJsonUrlProp = param.schemaOrgJsonUrl, _includeDefaultSchema = param.includeDefaultSchema, includeDefaultSchema = _includeDefaultSchema === void 0 ? false : _includeDefaultSchema, _shouldBeIndexed = param.shouldBeIndexed, shouldBeIndexed = _shouldBeIndexed === void 0 ? true : _shouldBeIndexed, breadcrumbList = param.breadcrumbList, _schemaType = param.schemaType, schemaType = _schemaType === void 0 ? "WebPage" : _schemaType, faqList = param.faqList, children = param.children;
    var title = titleProp !== null && titleProp !== void 0 ? titleProp : cityName ? "Vahak - Book Best Transport Services in ".concat(cityName) : undefined;
    var description = descriptionProp !== null && descriptionProp !== void 0 ? descriptionProp : cityName ? getCityMetaDescription(cityName) : undefined;
    var canonicalUrl = canonicalUrlProp !== null && canonicalUrlProp !== void 0 ? canonicalUrlProp : cityName ? "https://www.vahak.in/city/".concat(cityName) : undefined;
    var schemaOrgJsonUrl = schemaOrgJsonUrlProp !== null && schemaOrgJsonUrlProp !== void 0 ? schemaOrgJsonUrlProp : cityName ? "/city/".concat(cityName) : undefined;
    var ogImgAltText = ogImgAltTextProp !== null && ogImgAltTextProp !== void 0 ? ogImgAltTextProp : description;
    var seoConfig = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            title: title,
            description: description,
            keywords: keywords,
            asPath: asPath,
            locale: locale,
            localeNeutralPath: localeNeutralPath,
            hreflangLocales: hreflangLocales,
            canonicalUrl: asPath ? undefined : canonicalUrl,
            ogUrl: ogUrl,
            ogDescription: ogDescription,
            ogImgSrc: ogImgSrc,
            ogImgAltText: ogImgAltText,
            ogType: ogType,
            ogSiteName: ogSiteName,
            schema: schema,
            schemaOrgJsonUrl: schemaOrgJsonUrl,
            includeDefaultSchema: includeDefaultSchema,
            shouldBeIndexed: shouldBeIndexed,
            breadcrumbList: breadcrumbList,
            schemaType: schemaType,
            faqList: faqList
        };
    }, [
        title,
        description,
        keywords,
        asPath,
        locale,
        localeNeutralPath,
        hreflangLocales,
        canonicalUrl,
        ogUrl,
        ogDescription,
        ogImgSrc,
        ogImgAltText,
        ogType,
        ogSiteName,
        schema,
        schemaOrgJsonUrl,
        includeDefaultSchema,
        shouldBeIndexed,
        breadcrumbList,
        schemaType,
        faqList
    ]);
    (0,_seo_header_PageSeo__WEBPACK_IMPORTED_MODULE_3__/* .useRegisterPageSeo */ .C9)(seoConfig);
    if (!children) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageMetaTags);


/***/ }),

/***/ 62307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ useDefaultTopLayout; }
/* harmony export */ });
/* unused harmony export useHomePageDefaultLayout */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99456);
/* harmony import */ var _default_layout_DefaultLayout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78485);
/* harmony import */ var _dashboard_navbar_DashboardNavbar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51938);




var useDefaultTopLayout = function(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_1__/* .DefaultTopNavLayout */ .U1, {
        children: page
    });
};
var useHomePageDefaultLayout = function(page) {
    return /*#__PURE__*/ _jsx(DefaultLayout, {
        navContent: /*#__PURE__*/ _jsx(DashboardNav, {}),
        children: page
    });
};


/***/ }),

/***/ 24145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GW": function() { return /* binding */ getWhyChooseUsPageLayout; },
/* harmony export */   "Y$": function() { return /* binding */ getAboutUsPageLayout; },
/* harmony export */   "ad": function() { return /* binding */ getHowVahakHelpsPageLayout; },
/* harmony export */   "m2": function() { return /* binding */ getDefaultTopLayout; },
/* harmony export */   "sA": function() { return /* binding */ getContactUsPageLayout; }
/* harmony export */ });
/* unused harmony export getHomePageLayout */
/* harmony import */ var components_layout_layout_methods__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62307);

/***
 *  Default Layout
 */ var getDefaultTopLayout = components_layout_layout_methods__WEBPACK_IMPORTED_MODULE_0__/* .useDefaultTopLayout */ .E;
/***
 * About Us
 */ var getAboutUsPageLayout = components_layout_layout_methods__WEBPACK_IMPORTED_MODULE_0__/* .useDefaultTopLayout */ .E;
/***
 * how vahak helps
 */ var getHowVahakHelpsPageLayout = components_layout_layout_methods__WEBPACK_IMPORTED_MODULE_0__/* .useDefaultTopLayout */ .E;
/***
 * Contact Us
 */ var getContactUsPageLayout = components_layout_layout_methods__WEBPACK_IMPORTED_MODULE_0__/* .useDefaultTopLayout */ .E;
/***
 * Whu Choose Us
 */ var getWhyChooseUsPageLayout = components_layout_layout_methods__WEBPACK_IMPORTED_MODULE_0__/* .useDefaultTopLayout */ .E;
/***
 * Home
 */ var getHomePageLayout = (/* unused pure expression or super */ null && (useHomePageDefaultLayout));


/***/ }),

/***/ 51295:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"aboutusMainPage":"Aboutus_aboutusMainPage__mQL49"};

/***/ }),

/***/ 4261:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"advisorsInvestorsSection":"AdvisorsInvesters_advisorsInvestorsSection__cQ30n","heading":"AdvisorsInvesters_heading__zRbKB","ourTeamRow":"AdvisorsInvesters_ourTeamRow__j331z","ourTeamCol":"AdvisorsInvesters_ourTeamCol__IWMyE","imageBox":"AdvisorsInvesters_imageBox__MUJev","textBox":"AdvisorsInvesters_textBox__Iudxf","nameTitle":"AdvisorsInvesters_nameTitle__1G9CF","linkedIn":"AdvisorsInvesters_linkedIn__mmPBR","ourTeamCard":"AdvisorsInvesters_ourTeamCard__yReMD"};

/***/ }),

/***/ 80549:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bannerImg":"BannerDest_bannerImg__sfq0L","bannerSection":"BannerDest_bannerSection__lQHvi","aboutStoryCol":"BannerDest_aboutStoryCol__ebiKN","imgBgBox":"BannerDest_imgBgBox__fM_OC","storyImgWrap":"BannerDest_storyImgWrap__uq74K","bannerRow":"BannerDest_bannerRow__qYGMM","textCol":"BannerDest_textCol__CGTRP","text":"BannerDest_text__ANulG","ourStory":"BannerDest_ourStory__0fnDA","ourStoryText":"BannerDest_ourStoryText__XDq6F"};

/***/ }),

/***/ 50249:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bannerImg":"BannerMob_bannerImg__3k1Q2","bannerSection":"BannerMob_bannerSection__PDS7_","aboutStoryCol":"BannerMob_aboutStoryCol__p89A6","imgBgBox":"BannerMob_imgBgBox__chDrV","bannerRow":"BannerMob_bannerRow___2bJV","textCol":"BannerMob_textCol__ZSLke","ourStoryWrapper":"BannerMob_ourStoryWrapper__FGnU8","ourStory":"BannerMob_ourStory__6Z7Cj","ourStoryOuter":"BannerMob_ourStoryOuter__O_nf8","ourStoryImg":"BannerMob_ourStoryImg__TlRPp","ourStoryText":"BannerMob_ourStoryText__d7ko_"};

/***/ }),

/***/ 37365:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"joinOurFamSection":"JoinOurFam_joinOurFamSection__NtBi6","ourFamBGImg":"JoinOurFam_ourFamBGImg__9ekus","textBox":"JoinOurFam_textBox__ZNiBz","joinFam":"JoinOurFam_joinFam__ah6DL"};

/***/ }),

/***/ 59095:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"leadershipTeamSection":"LeadershipTeam_leadershipTeamSection__MiEkp","heading":"LeadershipTeam_heading__cYUER","ourTeamRow":"LeadershipTeam_ourTeamRow__FO6_o","ourTeamCol":"LeadershipTeam_ourTeamCol__pw6v1","imageBox":"LeadershipTeam_imageBox__gWKDF","textBox":"LeadershipTeam_textBox___KvSZ","nameTitle":"LeadershipTeam_nameTitle__SnzQT","linkedIn":"LeadershipTeam_linkedIn___luvi","ourTeamCard":"LeadershipTeam_ourTeamCard__pb_Ta"};

/***/ }),

/***/ 69232:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"weGrownlotSection":"WeGrownLot_weGrownlotSection__bxyCS","heading":"WeGrownLot_heading__z3g_7","indiaMaprow":"WeGrownLot_indiaMaprow__WJnjO","indiaMapCol":"WeGrownLot_indiaMapCol__dwsOJ","imgBox":"WeGrownLot_imgBox__jYTAD","locatorPin":"WeGrownLot_locatorPin__lSiu7","dot":"WeGrownLot_dot__5sn5o","curveLineOne":"WeGrownLot_curveLineOne__EZMrJ","curveLineTwo":"WeGrownLot_curveLineTwo__vMT6U","curveLineThree":"WeGrownLot_curveLineThree__Msmel","grownDtlCol":"WeGrownLot_grownDtlCol__9DV5K","grownBoxes":"WeGrownLot_grownBoxes__OyoBt","grownBox":"WeGrownLot_grownBox__aV0G6","lorryIcon":"WeGrownLot_lorryIcon__nB6l_","lorryLocatorMov":"WeGrownLot_lorryLocatorMov__iOCNf","curveOneWrap":"WeGrownLot_curveOneWrap__BWdBg","curveTwoWrap":"WeGrownLot_curveTwoWrap__PF5No","curveThreeWrap":"WeGrownLot_curveThreeWrap__TQnTX","curveAnim":"WeGrownLot_curveAnim__GI3eF","dotGroup":"WeGrownLot_dotGroup__ZJNSG","dotBlinking":"WeGrownLot_dotBlinking__Ub_PD"};

/***/ })

}]);